import { RedirectStyle } from '../types';
import { waitForWindowEvent } from './window-listener';

export type AuthTargetType = 'interop' | 'addin';

export function getAuthenticationUrl(
  interopHost: string,
  target: AuthTargetType = 'interop',
  landingPage?: string,
) {
  let url = `${interopHost}/api/oauth?target=${target}`;
  if (landingPage) {
    url += `&interopUrl=${encodeURIComponent(landingPage)}`;
  }
  return url;
}

async function redirectToAuthenticate(interopHost: string) {
  const landingPage = window.location.href;
  window.location.href = getAuthenticationUrl(
    interopHost,
    'interop',
    landingPage,
  );
}

async function authenticateInWindow(interopHost: string) {
  const newWindow = window.open(getAuthenticationUrl(interopHost), '_blank');
  await waitForWindowEvent('login');
  newWindow?.close();
}

export function authenticate(
  interopHost: string,
  redirectStyle: RedirectStyle = 'sameWindow',
) {
  if (redirectStyle === 'newWindow') {
    return authenticateInWindow(interopHost);
  }
  return redirectToAuthenticate(interopHost);
}
